exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.avatars{display:flex;margin:0;padding:0;flex-wrap:wrap;height:24px\n}\n.avatars .avatars-item{margin:0 0 5px 5px\n}\n.avatars .avatars-item:first-child{padding-left:5px\n}\n.avatars .avatars-item .avatar-small{border-radius:10px;border-radius:var(--avatarAltRadius, 10px);height:24px;width:24px\n}", ""]);

// exports
